import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-shipment-summary',
  template: `
    <span 
      *ngIf="data && allExist" 
      class="title secondary-title"
      translate>
      account.section.createConsignment.form.shipmentInfo.summaryTitle
    </span>
    <div class="summary-container" *ngIf="data">
      <ng-container *ngIf="showAddress && data">
        <span >{{address}}</span><br>
      </ng-container>
      <span class="bold">{{data?.quantity | numberFormat:'1.0-4'}}</span>
      <span *ngIf="data.quantity == 1">{{(data.type && data.type != 1 ? 'common.pallet' : 'common.package') | translate}}</span>
      <span *ngIf="data.quantity > 1">{{(data.type && data.type != 1 ? 'common.palletPlural' : 'common.packagePlural') | translate}}</span>
      <span class="bold">{{data?.volume | numberFormat:'1.0-4'}}</span>
      <span>m<sup>3</sup>,</span>
      <span class="extra-bold">{{data?.weight | numberFormat:'1.0-4'}}</span>
      <span>kg</span>
    </div>
  `,
  styles: [`
    .summary-container {
      padding: 0px;
      line-height: 1;
    }
    span {
      color: #666666;
      font-family: Roboto;
      font-size: 12px;
      font-weight: 400;
    }
    .bold {
      font-weight: 700;
    }
    .extra-bold {
      font-weight: 900;
    }
    .title {
      padding: 0;
    }
  `]
})
export class ShipmentSummaryComponent implements OnInit {
  @Input() data: any;
  @Input() showAddress: boolean = true;
  constructor() { }

  ngOnInit() {
  }

  get allExist () {
    return true;
  }
  get address(): Object {
    if (
      !this.data ||
      !this.data.from || !this.data.from.zip || !this.data.from.city || !this.data.from.country_code ||
      !this.data.to || !this.data.to.zip || !this.data.to.city || !this.data.to.country_code
    ) {
      return;
    }

    return `${this.data.from.zip.toUpperCase()} ${this.data.from.city.toUpperCase()}, ${this.data.from.country_code.toUpperCase()} - 
       ${this.data.to.zip.toUpperCase()} ${this.data.to.city.toUpperCase()}, ${this.data.to.country_code.toUpperCase()} `;
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/consignment/components/shipment-summary/shipment-summary.component.ts